import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";

import { ChartSellIn } from "components/Charts/ChartSellIn";
import BigNumberCard from "components/_refactor/card/big-number";

export default function CardRepresentantBillingOrders({ title, period, data, type }) {
  const month = type === "month";

  const initialDate = period?.initialDate;
  const finalDate = period?.finalDate;

  const formattedInitialDate = initialDate
    ?.split("-")
    .reverse()
    .join()
    .replaceAll(",", "/");
  const formattedFinalDate = finalDate
    ?.split("-")
    .reverse()
    .join()
    .replaceAll(",", "/");

  const periodString = `: ${formattedInitialDate} à ${formattedFinalDate}`;
  const cardTitle = period ? title + periodString : title;

  return (
    <Card>
      <CardHeader
        title={cardTitle}
        titleTypographyProps={{
          marginBottom: "0!important",
          variant: "h3",
          borderBottom: "2px solid #c0502a",
        }}
      />
      <CardContent>
        <Grid container justify="center">
          {data?.charts?.length > 0
            ? data?.charts?.map((item, i) => (
                <Grid
                  item
                  lg={month ? 3 : 4}
                  md={month ? 6 : 8}
                  sm={month ? 12 : 12}
                  key={i}
                >
                  {item?.openUrl ? (
                    <a href={item.openUrl}>
                      <BigNumberCard value={item.total} title={item.title} />
                    </a>
                  ) : (
                    <BigNumberCard value={item.total} title={item.title} />
                  )}

                  {!item.noChart ? (
                    <Box height="275px" width="100%" marginBottom="36px">
                      <ChartSellIn data={item.categories} />
                    </Box>
                  ) : null}
                </Grid>
              ))
            : null}
        </Grid>
        <Grid container style={{ marginTop: "20px" }}>
          {data?.bestSellerProducts?.length > 0 ? (
            <Grid item md={6} xs={12}>
              <Typography
                variant="h2"
                component={Box}
                style={{ marginTop: "1rem", color: "#000" }}
              >
                Produtos mais vendidos
              </Typography>
              <Box height="275px">
                <ChartSellIn data={data.bestSellerProducts} isHorizontal />
              </Box>
            </Grid>
          ) : null}
          {data?.bestCustomers?.length > 0 ? (
            <Grid item md={6} sx={12}>
              <Typography
                variant="h2"
                component={Box}
                style={{ marginTop: "1rem", color: "#000" }}
              >
                Ranking de clientes
              </Typography>
              <Box height="275px">
                <ChartSellIn data={data.bestCustomers} isHorizontal />
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </CardContent>
    </Card>
  );
}
